import classNames from "classnames";
import React, { CSSProperties, FunctionComponent, ReactNode, useRef } from "react";
import "./style.scss";

interface Props {
  children: ReactNode;
  distance?: number;
  placement: DOMRect | undefined;
  display: boolean;
}

const HALF_GUTTER_SIZE = 8;

const Tooltip: FunctionComponent<Props> = ({ children, distance, placement, display = false }) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  const styles: CSSProperties = {};
  styles.top = (placement?.bottom || 0) + HALF_GUTTER_SIZE;
  styles.left = placement ? placement.left + placement.width / 2 : 0;

  if (tooltipRef.current) {
    const tooltipSize = tooltipRef.current.getBoundingClientRect();
    styles.left = styles.left - tooltipSize.width / 2;
  }

  if (distance) {
    styles.marginTop = `${distance}px`;
  }

  return (
    <div
      className={classNames("Tooltip", { "Tooltip--hidden": display === false })}
      ref={tooltipRef}
      style={styles}
    >
      {children}
    </div>
  );
};

export default Tooltip;
